import { ReactElement, useMemo } from 'react';
import { Component } from 'react';
import { matchPath, RouteComponentProps, match } from 'react-router-dom';
import { AppScreen, AppScreenProps } from '../AppScreen/AppScreen';
// import { HeaderCenterNewVideo } from 'src/view/layout/HeaderCenter/NewVideo';
// import { ImageSelectionHeader } from 'src/view/components/ImageSelectionHeader';
// import { ImageSelector } from '../../view/screens/components/ImageSelector';
// import { ControlPanel } from '../../view/screens/NewVideo/step1/components/ControlPanel';
// import { StepNavigator } from '../../view/screens/NewVideo/components/StepNavigator';
import { LinkToCreators } from 'src/view/screens/components/CreatorSelector';
import { LinkToHome } from 'src/view/screens/components/LinkToHome';
import { LinkToMessages } from 'src/view/screens/components/LinkToMessages';
import { LinkToOrganization } from 'src/view/screens/components/LinkToOrganization';
import { ModuleNavigationSection } from 'src/view/screens/components/ModuleNavigationSection';
// import { useCurrentConsumerContext } from '../../view/screens/Home/NewHome/reducer';
// import { SelectConsumer } from '../../view/screens/components/buttons/SelectConsumer';
// import { Consumer } from 'src/domain/consumer';
// import { SelectRecipient } from '../../view/screens/components/buttons/SelectConsumer/SelectRecipient';
// import { HomeButton } from '../../view/screens/NewVideo/step2/components/HomeButton';
import { AccountButton } from '../Buttons/AccountButton';
import { House, Plus, Users } from 'lucide-react';
import { CaretIcon } from '../Icons/icons';
import { NavItem, NavButton } from '../Buttons/NavItem';
// import { SubmitPanel } from 'src/view/screens/ImageUpload/SubmitPanel';
import { SelectConsumerAsNextofkin } from 'src/view/screens/components/buttons/SelectConsumer/SelectConsumerAsNextOfKin';
// import { LogoLink } from '../Buttons/LogoLink';
// import { RepeatOnboardingButton } from '../Buttons/RepeatOnboardingButton';
import { OrganizationSelector } from 'src/view/screens/Admin/OrganizationSelector';
import {
    useTranslation,
    withTranslation,
    WithTranslation,
} from 'react-i18next';
import { TFunction } from 'i18next';
import { useCreatorRoleContext } from 'src/view/hooks/useCreatorRoleContext';
import { useCurrentOrganization } from 'src/view/hooks/useCurrentOrganization';
import { getUniqueLeafHierarchyName } from 'src/domain/organization/hierarchy';
// import { useSignedInUser } from 'src/view/hooks/useSignedInUser';
// import { getPrimaryRole, isOrganizationRole } from 'src/domain/user';

type ModuleParams = {
    match?: match<RouteParams>;
    loading: boolean;
    prevKey: string;
    setLoading?: () => void;
    children: ReactElement;
};

// const CurrentConsumerSelect = ({
//     isLight,
//     disabled = false,
// }: {
//     isLight?: boolean;
//     disabled?: boolean;
// }) => {
//     const {
//         dispatch,
//         state: { currentConsumer },
//     } = useCurrentConsumerContext();

//     const onSelect = (consumer: Consumer) => {
//         dispatch({
//             type: 'SELECT_CONSUMER',
//             payload: consumer,
//         });
//     };
//     return (
//         <SelectConsumer
//             onSelect={onSelect}
//             current={currentConsumer?.id}
//             isLight={isLight}
//             disabled={disabled}
//         />
//     );
// };

// const NewCreatorNavButton = ({
//     label,
//     isActive,
// }: {
//     label: string;
//     isActive: boolean;
// }) => {
//     const user = useSignedInUser();
//     const role = getPrimaryRole(user);

//     if (!isOrganizationRole(role)) {
//         return null;
//     }

//     return (
//         <NavButton
//             key="new-creator"
//             leadingIcon={Plus}
//             to={'/app/creators/new'}
//             label={label}
//             isActive={isActive}
//         />
//     );
// };

// const NewConsumerNavButton = ({
//     label,
//     isActive,
// }: {
//     label: string;
//     isActive: boolean;
// }) => {
//     const user = useSignedInUser();
//     const role = getPrimaryRole(user);

//     if (!isOrganizationRole(role)) {
//         return null;
//     }

//     return (
//         <NavButton
//             key="new-consumer"
//             leadingIcon={Plus}
//             to={'/app/users/new'}
//             label={label}
//             isActive={isActive}
//         />
//     );
// };

const Module = ({ children }: ModuleParams) => {
    return <span className="animate-fade-in-fast">{children}</span>;
};
const getParams = (pathname: string) => {
    const matchModule = matchPath<RouteParams>(pathname, {
        path: `/app/:moduleName/:tabName?/:subModule?`,
    });
    return matchModule?.params ?? {};
};

const DefaultHeader = ({ title }: { title: string }) => (
    <div className="inline-flex justify-start w-full items-center text-xl space-x-8">
        <h1 className="font-logo opacity-80 whitespace-nowrap">{title}</h1>
    </div>
);

const MainNavItems = () => {
    const { t } = useTranslation();

    return (
        <>
            <LinkToHome />
            <LinkToCreators />
            <NavItem
                icon={Users}
                screen="/app/users"
                label={t('modules.users.navLabel')}
                indentChildren={false}
            />
            <LinkToMessages />
            <ModuleNavigationSection />
            <LinkToOrganization />
        </>
    );
};

const RoleHeader = ({ title }: { title: string }) => {
    const { t } = useTranslation();
    const { activeRoleId, isCreator, roles, setActiveRoleId } =
        useCreatorRoleContext();

    if (!isCreator || roles.length === 0) {
        return <DefaultHeader title={title} />;
    }

    const activeId = activeRoleId ?? roles[0]?.id;
    const activeRoleName =
        roles.find(role => role.id === activeId)?.name || activeId || title;

    return (
        <div className="relative inline-flex items-center gap-1">
            <h1 className="opacity-80 whitespace-nowrap cursor-pointer select-none text-lg md:text-xl">
                <span className="font-semibold">{title}</span>
                <span className="font-medium">{` | ${activeRoleName}`}</span>
            </h1>
            {roles.length > 1 && activeId && (
                <button
                    type="button"
                    className="inline-flex items-center text-woodyBrown ml-1 w-4 h-4 relative stroke-2"
                    aria-label={t('modules.users.navLabel')}
                >
                    <CaretIcon />
                </button>
            )}
            {roles.length > 1 && activeId && (
                <select
                    aria-label={t('modules.users.navLabel')}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    value={activeId}
                    onChange={event => setActiveRoleId(event.target.value)}
                >
                    {roles.map(role => (
                        <option key={role.id} value={role.id}>
                            {role.name || role.id}
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
};

const UsersHeader = ({ tabName }: { tabName?: string }) => {
    const { t } = useTranslation();
    const baseTitle = t(
        tabName === 'new'
            ? 'modules.users.headerNew'
            : 'modules.users.navLabel',
    );

    return <RoleHeader title={baseTitle} />;
};

const GroupsHeader = () => {
    const { t } = useTranslation();
    const { organization } = useCurrentOrganization();

    const leafLevelName = useMemo(
        () => getUniqueLeafHierarchyName(organization?.hierarchy ?? []),
        [organization?.hierarchy],
    );

    const title = leafLevelName || t('users.leafGroups.title');

    return <RoleHeader title={title} />;
};

const CreatorsHeader = ({ tabName }: { tabName?: string }) => {
    const { t } = useTranslation();
    const baseTitle =
        tabName === 'new'
            ? t('modules.creators.headerNew')
            : tabName === 'profile'
            ? t('modules.creators.headerProfile')
            : t('modules.creators.headerDefault');

    if (tabName === 'new') {
        return <DefaultHeader title={baseTitle} />;
    }

    return <RoleHeader title={baseTitle} />;
};

const getScreenProps = (
    t: TFunction,
    moduleName?: string,
    tabname?: string,
    subModule?: string,
    pathname?: string,
): AppScreenProps => {
    switch (moduleName) {
        case 'admin':
            const isOrganizationEdit =
                tabname === 'organizations' &&
                pathname?.startsWith('/app/admin/organizations/') &&
                pathname?.endsWith('/edit');
            const adminHeaderTitle =
                tabname === 'organizations'
                    ? isOrganizationEdit
                        ? t('modules.admin.editOrganization')
                        : t('modules.admin.newOrganization')
                    : tabname === 'admins'
                    ? t('modules.admin.newAdmin')
                    : tabname === 'organization'
                    ? t('modules.admin.organizationDetail', {
                          name: subModule,
                      })
                    : t('modules.admin.title');

            return {
                HeaderLeft: (
                    <div className="inline-flex justify-start w-full items-center text-xl space-x-8 ">
                        <h1 className="font-logo opacity-80 whitespace-nowrap">
                            {adminHeaderTitle}
                        </h1>
                    </div>
                ),
                HeaderRight: <AccountButton />,
                NavItems: (
                    <>
                        <NavItem
                            icon={House}
                            screen={'/app/admin'}
                            exact
                            label={t('nav.home')}
                        />

                        <NavItem
                            icon={Users}
                            screen={'/app/organizations'}
                            label={t('modules.admin.navOrganizations')}
                            indentChildren={false}
                            isActive={true}
                        >
                            <OrganizationSelector />
                        </NavItem>
                        <NavButton
                            key="kebab"
                            leadingIcon={Plus}
                            to={'/app/admin/organizations/new'}
                            label={t('modules.admin.newOrganization')}
                            isActive={'new' === tabname}
                        />
                    </>
                ),
            };
        case 'me':
            return {};
        // case 'new-video': {
        //     if (subModule === 'browse') {
        //         return {
        //             HeaderLeft: <SelectRecipient />,
        //             HeaderRight: <AccountButton />,
        //             HeaderCenter: <HeaderCenterNewVideo />,

        //             // HeaderCenter: <SubHeader />,
        //             navOnTheRight: true,
        //             sidebarIsNextStep: true,
        //         };
        //     } else if (subModule === 'personalmedia') {
        //         return {
        //             // SubHeader: <SubHeader />,
        //             HeaderLeft: <SelectRecipient />,
        //             ContentHeader: <ImageSelectionHeader />,
        //             HeaderRight: <AccountButton />,
        //             HeaderCenter: <HeaderCenterNewVideo />,
        //             Selector: <ImageSelector />,
        //             navOnTheRight: true,
        //             sidebarIsNextStep: true,
        //         };
        //     } else if (tabname === 'step1') {
        //         return {
        //             HeaderLeft: <SelectRecipient />,
        //             SubHeader: <StepNavigator />,
        //             HeaderRight: <AccountButton />,
        //             HeaderCenter: <HeaderCenterNewVideo />,
        //             Selector: <ControlPanel />,
        //             navOnTheRight: true,
        //             sidebarIsNextStep: true,
        //         };
        //     } else if (tabname === 'step3') {
        //         return {
        //             HeaderLeft: <SelectRecipient />,
        //             HeaderRight: <AccountButton />,
        //             sidebarIsNextStep: false,
        //         };
        //     } else {
        //         return {
        //             HeaderLeft: <SelectRecipient />,
        //             HeaderRight: <AccountButton />,
        //             SubHeader: <StepNavigator />,
        //             HeaderCenter: <HeaderCenterNewVideo />,
        //         };
        //     }
        // }
        case 'home': {
            return {
                HeaderLeft: (
                    <div className="inline-flex justify-start w-full items-center text-xl space-x-8">
                        <h1 className="font-logo opacity-80 whitespace-nowrap">
                            {t('nav.home')}
                        </h1>
                    </div>
                ),
                // <CurrentConsumerSelect />,
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
                NavItems: <MainNavItems />,
            };
        }
        case 'messages': {
            return {
                HeaderLeft: (
                    <RoleHeader title={t('modules.messages.navLabel')} />
                ),
                // <CurrentConsumerSelect disabled />,
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
                NavItems: <MainNavItems />,
            };
        }
        case 'calendar': {
            return {
                HeaderLeft: (
                    <RoleHeader title={t('modules.calendar.navLabel')} />
                ),
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
                NavItems: <MainNavItems />,
            };
        }
        case 'documents': {
            return {
                HeaderLeft: (
                    <DefaultHeader title={t('modules.appContent.navLabel')} />
                ),
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
                NavItems: <MainNavItems />,
            };
        }
        case 'groups': {
            return {
                HeaderLeft: <GroupsHeader />,
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
                NavItems: <MainNavItems />,
            };
        }
        case 'users': {
            return {
                HeaderLeft: <UsersHeader tabName={tabname} />,
                // 'new' === tabname ? (
                //     <div className="inline-flex justify-start w-full items-center text-xl space-x-8 ">
                //         <h1 className="font-logo opacity-80 whitespace-nowrap">
                //             {t('modules.users.headerNew')}
                //         </h1>
                //     </div>
                // ) : (
                //     <CurrentConsumerSelect disabled />
                // ),
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
                NavItems: <MainNavItems />,

                // Selector: <ConsumerSelector />,
            };
        }
        case 'nextofkins': {
            return {
                HeaderLeft: <>{/* <CurrentConsumerSelect disabled /> */}</>,
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
                NavItems: <MainNavItems />,
            };
        }
        // case 'image-upload': {
        //     return {
        //         ContentHeader: (
        //             <div className="inline-flex w-full justify-between items-center">
        //                 <HomeButton title={t('nav.home')} />
        //             </div>
        //         ),
        //         HeaderLeft: <CurrentConsumerSelect disabled />,
        //         HeaderRight: (
        //             <>
        //                 <AccountButton />
        //             </>
        //         ),
        //         Selector: <SubmitPanel />,
        //         navOnTheRight: true,
        //         sidebarIsNextStep: true,
        //     };
        // }
        // case 'nextofkin-image-upload': {
        //     return {
        //         ContentHeader: (
        //             <div className="inline-flex w-full justify-between items-center">
        //                 <HomeButton title={t('nav.home')} />
        //             </div>
        //         ),
        //         HeaderLeft: (
        //             <SelectConsumerAsNextofkin onSelect={() => null} disabled />
        //         ),
        //         HeaderRight: (
        //             <>
        //                 <AccountButton />
        //             </>
        //         ),
        //         Selector: <SubmitPanel isNextofkin={true} />,
        //         navOnTheRight: true,
        //         sidebarIsNextStep: true,
        //     };
        // }
        // case 'nextofkin-image-list': {
        //     return {
        //         HeaderLeft: (
        //             <SelectConsumerAsNextofkin onSelect={() => null} disabled />
        //         ),
        //         HeaderRight: (
        //             <>
        //                 <RepeatOnboardingButton isLight />
        //                 <AccountButton />
        //             </>
        //         ),
        //     };
        // }
        case 'nextofkin-profile': {
            return {
                // ContentHeader: (
                //     <div className="inline-flex w-full justify-between items-center">
                //         <HomeButton title={t('nav.home')} />
                //     </div>
                // ),
                HeaderLeft: (
                    <SelectConsumerAsNextofkin onSelect={() => null} disabled />
                ),
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
            };
        }
        case 'my-profile': {
            return {
                HeaderLeft: (
                    <div className="inline-flex justify-start w-full items-center text-xl space-x-8">
                        <h1 className="font-logo opacity-80 whitespace-nowrap">
                            {t('modules.myProfile.title')}
                        </h1>
                    </div>
                ),
                // ContentHeader: (
                //     <div className="inline-flex w-full justify-between items-center">
                //         <HomeButton title={t('nav.home')} />
                //     </div>
                // ),
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
                NavItems: <MainNavItems />,
            };
        }
        case 'organization': {
            return {
                HeaderLeft: (
                    <div className="inline-flex justify-start w-full items-center text-xl space-x-8">
                        <h1 className="font-logo opacity-80 whitespace-nowrap">
                            {t('modules.organization.navLabel')}
                        </h1>
                    </div>
                ),
                // ContentHeader: (
                //     <div className="inline-flex w-full justify-between items-center">
                //         <HomeButton title={t('nav.home')} />
                //     </div>
                // ),
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
                NavItems: <MainNavItems />,
            };
        }
        case 'creators': {
            return {
                HeaderLeft: <CreatorsHeader tabName={tabname} />,
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
                NavItems: <MainNavItems />,
            };
        }
        case 'info-screen': {
            return {
                HeaderLeft: (
                    <DefaultHeader title={t('modules.infoScreen.header')} />
                ),
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
                NavItems: <MainNavItems />,
            };
        }
        case 'analytics': {
            return {
                HeaderLeft: (
                    <DefaultHeader title={t('modules.analytics.navLabel')} />
                ),
                HeaderRight: (
                    <>
                        <AccountButton />
                    </>
                ),
                NavItems: <MainNavItems />,
            };
        }

        // case 'video':
        default: {
            return {};
        }
    }
};

type RouteParams = {
    subModule?: string;
    moduleName?: string;
    tabName?: string;
    id?: string;
};

type State = {
    loading: boolean;
    tabName?: string;
    screenProps: AppScreenProps;
    prevKey: string;
};

type ModuleSelectorRouteProps = RouteComponentProps<{
    moduleName?: string;
    tabName?: string;
    subModule?: string;
    id?: string;
}> &
    Readonly<{
        children: (key: string) => ReactElement;
    }>;

type Props = ModuleSelectorRouteProps & WithTranslation;

class ModuleSelectorComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        const { t } = props;
        const { moduleName, tabName, subModule } = getParams(
            props.location.pathname,
        );
        this.state = {
            screenProps: getScreenProps(
                t,
                moduleName,
                tabName,
                subModule,
                props.location.pathname,
            ),
            loading: false,
            prevKey: '',
            tabName,
        };
    }
    onClickTabItem(tabName: string) {
        this.setState({ tabName });
    }
    loadModule = (onLoad: () => void) => {
        return new Promise(resolve => {
            setTimeout(() => resolve(onLoad()), 200);
        });
    };

    async componentDidUpdate(prevProps: Props) {
        const { pathname } = this.props.location;
        const { t } = this.props;
        const { pathname: prevPathname } = prevProps.location;
        const { moduleName, tabName, subModule } = getParams(pathname);
        const prevParams = getParams(prevPathname);

        if (pathname === '/app' && pathname !== prevPathname) {
            this.setState({ loading: true });
            const screenProps = getScreenProps(
                t,
                moduleName,
                tabName,
                subModule,
                pathname,
            );
            this.setState({ screenProps: screenProps });
            this.loadModule(() => {
                this.setState({ loading: false });
            });
            this.setState({ prevKey: prevPathname });
        }
        if (
            (moduleName && moduleName !== prevParams.moduleName) ||
            (subModule && prevParams.subModule === undefined) ||
            (!subModule && prevParams.subModule !== undefined)
        ) {
            this.setState({ loading: true });
            const screenProps = getScreenProps(
                t,
                moduleName,
                tabName,
                subModule,
                pathname,
            );
            this.setState({ screenProps: screenProps });
            this.loadModule(() => {
                this.setState({ loading: false });
            });
            this.setState({ prevKey: prevPathname });
        } else if (tabName && tabName !== prevParams.tabName) {
            const screenProps = getScreenProps(
                t,
                moduleName,
                tabName,
                subModule,
                pathname,
            );
            this.setState({ screenProps: screenProps });
            // this.setState({
            //     loading: true,
            // });
            // this.loadModule();
            // const screenProps = await getTabProps(tabName);
            // this.setState({ screenProps: screenProps });
        }
    }

    render() {
        const { screenProps, loading } = this.state;
        return (
            <AppScreen {...screenProps}>
                <Module prevKey={this.state.prevKey} loading={loading}>
                    {this.props.children(this.props.match.url)}
                </Module>
            </AppScreen>
        );
    }
}

const ModuleSelector = withTranslation()(ModuleSelectorComponent);

export { ModuleSelector };
